import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class HttpEventService {
  private errorSubject = new Subject<any>();
  error$ = this.errorSubject.asObservable();

  emitError(error: any) {
    this.errorSubject.next(error);
  }
}

